module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if ( currentLevelHeader ) { ;
__p += '\n    <div class="mdl_categeorychips__header">\n        ';
 if ( currentLevelHeader.searchParams ) { ;
__p += '\n            <button type="button" class="mdl_categeorychips__header-back-trigger" data-search-params=\'' +
((__t = ( JSON.stringify( currentLevelHeader.searchParams ) )) == null ? '' : __t) +
'\'>\n                <svg xmlns="http://www.w3.org/2000/svg" height="13.175" width="6.489" viewBox="0 0 6.489 13.175">\n                    <g id="Gruppe_1344" transform="translate(-409.592 299.337) rotate(-90)">\n                        <line id="Linie_386" x1="292.4" y1="410.2" x2="298.9" y2="415.4" fill="none" stroke="currentColor" stroke-width="1.5"/>\n                        <line id="Linie_387" x1="286.6" y1="415.5" x2="293.1" y2="410.2" fill="none" stroke="currentColor" stroke-width="1.5"/>\n                    </g>\n                </svg>\n            </button>\n        ';
 } ;
__p += '\n        <div class="mdl_categeorychips__header-current">' +
((__t = ( currentLevelHeader.title )) == null ? '' : __t) +
' (' +
((__t = ( currentLevelHeader.totalHits )) == null ? '' : __t) +
')</div>\n    </div>\n';
 } ;
__p += '\n\n<ul class="mdl_categeorychips__list">\n    ';
 elems.forEach( ( elem, index ) => { ;
__p += '\n        <li class="mdl_categeorychips__item">\n            <button type="button" class="mdl_categeorychips__item-trigger' +
((__t = ( elem.selected === 'TRUE' || elem.selected === 'IMPLICIT' ? ' is-selected' : '' )) == null ? '' : __t) +
'" data-search-params=\'' +
((__t = ( JSON.stringify( elem.searchParams ) )) == null ? '' : __t) +
'\'>\n                ' +
((__t = ( elem.text )) == null ? '' : __t) +
' (' +
((__t = ( elem.totalHits )) == null ? '' : __t) +
')\n            </button>\n        </li>\n    ';
 } ) ;
__p += '\n</ul>\n\n\n\n\n';

}
return __p
};
